











import Vue from 'vue';

const SHORT_DESCRIPTION_LENGTH = 70;

export default Vue.component('TruncatedText', {

  props: {
    text: String,
    length: Number,
    moreClass: String,
  },
  data() {
    return { showMoreFlag: false };
  },
  methods: {
    showMore() {
      this.showMoreFlag = true;
    },
    showLess() {
      this.showMoreFlag = false;
    },
    isDisplayTruncated(): boolean {
      return this.showMoreFlag || !this.isDescriptionTruncated(this.text);
    },
    isDescriptionTruncated(desc: string): boolean {
      return this.text?.length > this.truncateLength();
    },
    truncateLength(): number {
      return this.length ? this.length : SHORT_DESCRIPTION_LENGTH;
    },
    truncatedDescription(desc: string): string {
      if (desc) {
        if (desc.length <= SHORT_DESCRIPTION_LENGTH) {
          return desc;
        }
        return desc.slice(0, Math.min(desc.length, this.truncateLength()));
      }
      return '';
    },
  },
});
